import React, { useState, useEffect, useRef } from 'react';

// material ui
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
// validator
import isNumeric from 'validator/lib/isNumeric';
import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';

function SubForm01({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, navigationMode, handleBackSub, no_kk, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [useModernContrasep, setUseModernContrasep] = useState(false);

    const [jenisKb, setJenisKb] = useState(value.info_jenis_kb || '')
    const [efekSamping, setEfekSamping] = useState(value.info_efek_samping_kb || '')
    const [infoEfekSamping, setInfoEfekSamping] = useState(value.info_jika_mengalami_efek || '')
    
    const [nakesTerampil, setNakesTerampil] = useState(value.nakes_terampil || '')
    const [nakesPelayananKebutuhan, setNakesPelayananKebutuhan] = useState(value.nakes_pelayanan_kebutuhan || '')
    const [nakesInteraksiAmanNyaman, setNakesInteraksiAmanNyaman] = useState(value.nakes_interaksi_aman_nyaman || '')
    const [nakesMenyampaikanJadwal, setNakesMenyampaikanJadwal] = useState(value.nakes_menyampaikan_jadwal || '')

    const pertanyaan = "Pada saat mendapatkan alat/obat/cara kontrasepsi terakhir, menurut Ibu atau Suami, apakah tenaga kesehatan:";

    useEffect(() => {

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 9,
            No_KK: no_kk,
            answer: [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: 1,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: nakesTerampil,
                    Lainnya: ""
                },
                {
                    _id: `${no_kk}${id}02`,
                    No_Jawaban: 2,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: nakesPelayananKebutuhan,
                    Lainnya: ""
                },
                {
                    _id: `${no_kk}${id}03`,
                    No_Jawaban: 3,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: nakesInteraksiAmanNyaman,
                    Lainnya: ""
                },
                {
                    _id: `${no_kk}${id}04`,
                    No_Jawaban: 4,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: nakesMenyampaikanJadwal,
                    Lainnya: ""
                }
            ]

        }

        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        saveValueJump(normalizeValue)

    }, [nakesTerampil, nakesPelayananKebutuhan, nakesInteraksiAmanNyaman, nakesMenyampaikanJadwal])
    
    useEffect(() => {
        setError({})

        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            if (kb["0106"].jenis_kontrasepsi === "9") {

                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["pelayanan_nakes"]: undefined
                    }
                })
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }
            } else {
                setUseModernContrasep(true);
            }
        } else if (kb["0102"].sedang_hamil === "1" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

            let normalizeValue = {}
            setKB({
                ...kb,
                [id]: {
                    ...kb[id],
                    ["pelayanan_nakes"]: undefined
                }
            })
            if (navigationMode === 'back') {
                handleBackSub();
            } else {
                handleNextSub()
                saveValueJump(normalizeValue)
            }
        } else {
            if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["pelayanan_nakes"]: undefined
                    }
                })
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }


            } else {
                if (kb["0106"].jenis_kontrasepsi === "9") {
                    let normalizeValue = {}
                    setKB({
                        ...kb,
                        [id]: {
                            ...kb[id],
                            ["pelayanan_nakes"]: undefined
                        }
                    })
                    if (navigationMode === 'back') {
                        handleBackSub();
                    } else {
                        handleNextSub()
                        saveValueJump(normalizeValue)
                    }
                } else {
                    setUseModernContrasep(true);
                }

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!useModernContrasep) {
        return null
    }
    
    const handleChange = (e) => {

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        switch (e.target.name) {
            case 'nakes_terampil':
            setNakesTerampil(e.target.value)
            break;
            case 'nakes_pelayanan_kebutuhan':
            setNakesPelayananKebutuhan(e.target.value)
            break;
            case 'nakes_interaksi_aman_nyaman':
            setNakesInteraksiAmanNyaman(e.target.value)
            break;
            case 'nakes_menyampaikan_jadwal':
            setNakesMenyampaikanJadwal(e.target.value)
            break;
            default:
                break;
        }

        // setSomethingChange(true)
    }

    const validate = () => {
        let newError = {};

        if (!value.nakes_terampil) {
            newError.nakes_terampil = "Wajib diisi";
        }

        if (!value.nakes_pelayanan_kebutuhan) {
            newError.nakes_pelayanan_kebutuhan = "Wajid diisi";
        }

        if (!value.nakes_interaksi_aman_nyaman) {
            newError.nakes_interaksi_aman_nyaman = "Wajib diisi";
        }

        if (!value.nakes_menyampaikan_jadwal) {
            newError.nakes_menyampaikan_jadwal = "Wajib diisi";
        }

        return newError;
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 9,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: 1,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.nakes_terampil,
                        Lainnya: ""
                    },
                    {
                        _id: `${no_kk}${id}02`,
                        No_Jawaban: 2,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.nakes_pelayanan_kebutuhan,
                        Lainnya: ""
                    },
                    {
                        _id: `${no_kk}${id}03`,
                        No_Jawaban: 3,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.nakes_interaksi_aman_nyaman,
                        Lainnya: ""
                    },
                    {
                        _id: `${no_kk}${id}04`,
                        No_Jawaban: 4,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.nakes_menyampaikan_jadwal,
                        Lainnya: ""
                    }
                ]

            }
            if (value._rev) {
                normalizeValue._rev = value._rev
            }
            saveValue(normalizeValue)
        }
    }
    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>09</span>Pada saat mendapatkan alat/obat/cara kontrasepsi terakhir, menurut Ibu atau Suami, apakah <strong>tenaga kesehatan</strong>:</Typography>
                <div style={{ position: "absolute", right: "0", top: "82px" }}>
                    <InfoButton
                        content={
                            "Pada saat mendapatkan pelayanan kontrasepsi terakhir, apakah provider (dokter/bidan/petugas sesuai dengan fasyankes dimana responden dilayani) kompeten dan memiliki pengetahuan yang baik tentang KB sehingga dapat memberikan pelayanan yang berkualitas kepada klien (responden)."+
                            "\n\nBerhasil melakukan tindakan pelayanan kontrasepsi dengan terampil?"+
                            "\nDiisi ya, jika provider secara teknis mampu melakukan screening klien (responden) untuk mengidentifikasi kontraindikasi dan mampu memberikan pelayanan klinis secara efektif."+
                            "\n\nMemberikan pelayanan kontrasepsi sesuai kebutuhan Ibu atau Suami?"+
                            "\nDiisi ya, jika provider mencari informasi mengenai latar belakang klien (responden), tujuan reproduksinya, pengalaman-pengalaman yang pernah dimiliknya dengan metode kontrasepsi, dan preferensinya, kemudian membantunya memilih alat kontrasepsi yang diinginkannya"+
                            "\n\nMampu berinteraksi serta memberikan rasa aman dan nyaman saat pelayanan kontrasepsi?"+
                            "\nDiisi ya, jika provider memperlakukan klien (responden) secara wajar dan manusiawi, melindungi rahasia pribadinya, berbagi rasa dan informasi, dan melakukan wawancara secara interpersonal."+
                            "\n\nMenyampaikan untuk selalu menggunakan kontrasepsi dengan memberitahukan jadwal kunjungan ulang atau kontrol?"+
                            "\nDiisi ya, jika klien (responden) menerima informasi mengenai kemungkinan penggantian metode kontrasepsi, atau sumber-sumber suplai pelayanan dan membuat jadwal pelayanan lanjutan."
                        }
                    />
                </div>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography>Berhasil melakukan tindakan pelayanan kontrasepsi dengan terampil?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.nakes_terampil ? true : false} component="fieldset">
                            <RadioGroup value={value.nakes_terampil || ''}
                                onChange={handleChange}
                                aria-label="nakes_terampil" name="nakes_terampil" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.nakes_terampil}</FormHelperText>
                        </FormControl>

                    </Grid>

                    <Grid item xs={12}>
                        <Typography>Memberikan pelayanan kontrasepsi sesuai kebutuhan Ibu atau Suami?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.nakes_pelayanan_kebutuhan ? true : false} component="fieldset">
                            <RadioGroup value={value.nakes_pelayanan_kebutuhan || ''}
                                onChange={handleChange}
                                aria-label="nakes_pelayanan_kebutuhan" name="nakes_pelayanan_kebutuhan" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.nakes_pelayanan_kebutuhan}</FormHelperText>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12}>
                        <Typography>Mampu berinteraksi serta memberikan rasa aman dan nyaman saat pelayanan kontrasepsi?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.nakes_interaksi_aman_nyaman ? true : false} component="fieldset">
                            <RadioGroup value={value.nakes_interaksi_aman_nyaman || ''}
                                onChange={handleChange}
                                aria-label="nakes_interaksi_aman_nyaman" name="nakes_interaksi_aman_nyaman" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.nakes_interaksi_aman_nyaman}</FormHelperText>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12}>
                        <Typography>Menyampaikan untuk selalu menggunakan kontrasepsi dengan memberitahukan jadwal kunjungan ulang atau kontrol?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.nakes_menyampaikan_jadwal ? true : false} component="fieldset">
                            <RadioGroup value={value.nakes_menyampaikan_jadwal || ''}
                                onChange={handleChange}
                                aria-label="nakes_menyampaikan_jadwal" name="nakes_menyampaikan_jadwal" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.nakes_menyampaikan_jadwal}</FormHelperText>
                        </FormControl>

                    </Grid>


                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubForm01;